import { areFieldsSet } from '@superbet-group/web.lib.utilities';

import Message from '@core/models/user/pushNotifications/Message';

import { transformAction } from '@core/mappers/user/pushNotifications/transformAction';
import { transformMessageData } from '@core/mappers/user/pushNotifications/transformMessageData';
import { MessageDto } from '@core/mappers/user/pushNotifications/dtos/MessageDto';
import { getMessageTypeMapper } from '@core/mappers/user/pushNotifications/transformMessageType';

const transformMessageType = getMessageTypeMapper();

export function transformMessage(obj: MessageDto): Message {
    const message: Message = {
        transactionalType: obj.Message.TransactionalMessageName,
        content: obj.Message.Contents,
        title: obj.Message.Title,
        actions: obj.Message.Actions.map(transformAction),
        messageType: transformMessageType(obj),

        ...areFieldsSet(obj.Message, 'Data') && { data: transformMessageData(obj.Message.Data) },
        ...areFieldsSet(obj.Message, 'Parameters') && { bonusTitle: obj.Message.Parameters.BonusFriendlyName || obj.Message.Parameters.BonusName },
    };
    return message;
}
